// Liste complète des secteurs d'activité en France
export const businessSectors = [
  'Aéronautique et spatial',
  'Agriculture et agroalimentaire',
  'Artisanat',
  'Assurance et mutuelle',
  'Automobile',
  'Banque et services financiers',
  'Bois et papier',
  'BTP et construction',
  'Chimie et matériaux',
  'Commerce de détail',
  'Commerce de gros',
  'Communication et médias',
  'Conseil et services aux entreprises',
  'Culture et arts',
  'Défense et sécurité',
  'Distribution',
  'E-commerce',
  'Éducation et formation',
  'Énergie',
  'Environnement et développement durable',
  'Hôtellerie et hébergement',
  'Immobilier',
  'Industrie cosmétique',
  'Industrie du luxe',
  'Industrie électronique',
  'Industrie manufacturière',
  'Industrie pharmaceutique',
  'Informatique et numérique',
  'Logistique et transport',
  'Marketing et publicité',
  'Métallurgie et sidérurgie',
  'Mode et textile',
  'Recherche et développement',
  'Ressources humaines',
  'Restauration',
  'Santé et action sociale',
  'Services à la personne',
  'Sport et loisirs',
  'Télécommunications',
  'Tourisme',
  'Transport public',
  'Vente et distribution'
].sort();

// Sous-secteurs détaillés
export const subSectors = {
  'Aéronautique et spatial': [
    'Construction aéronautique',
    'Maintenance aéronautique',
    'Spatial et satellites',
    'Équipements aéronautiques'
  ],
  'Agriculture et agroalimentaire': [
    'Agriculture biologique',
    'Élevage',
    'Industrie agroalimentaire',
    'Viticulture'
  ],
  'Distribution': [
    'Grande distribution',
    'Distribution spécialisée',
    'Distribution alimentaire',
    'Distribution de produits professionnels',
    'Commerce de gros'
  ],
  // ... autres sous-secteurs
};